import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { addreessesService } from "services";
import { IAddressee } from "config/interfaces";
import { initialState } from "config/Addressees";
import { useSession } from "context/SessionContext";
import { useError } from "hooks";

import {
  getLevelUser,
  concatArray,
  concatArrayAndFormatData,
  phoneWithMask,
  formatPhone,
} from "utils";
import { useRouter } from "hooks";
// import ListInstallsContext from "context/ListInstallsContext";

const initialData = Object.freeze(initialState);
let data = { ...initialData };
// let addreesses = [] as IAddressee.Addressee[];

export default function useAddreesse(addresseeId?: string) {
  const { verifyError } = useError();
  const [loading, setLoading] = useState(false);
  const [addreesses, setAddreesses] = useState([] as IAddressee.Addressee[]);
  const [selectedRows, setSelectedRows] = useState(
    [] as Array<IAddressee.Addressee>
  );

  // const [update, force] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successActivate, setSuccessActivate] = useState(false);
  const [successInactivate, setSuccessInactivate] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { IDMCM } = useSession();
  // const { update } = useContext(ListInstallsContext);
  const router = useRouter();

  const endComplement = (adressArray: any) => {
    if (adressArray.length === 0) return "";
    let finalString = "";
    adressArray.forEach((item: any) => {
      if (item.DSCOMPLEMENTO) {
        if (item.VLCOMPLEMENTO) {
          finalString =
            finalString + item.DSCOMPLEMENTO + " " + item.VLCOMPLEMENTO + " | ";
        } else {
          finalString = `${finalString + item.DSCOMPLEMENTO} - | `
          // finalString + item.DSCOMPLEMENTO + " " + "-" + " | ";
        }
      }
    });
    return finalString;
    // const string = `${adressArray[0]?.DSCOMPLEMENTO ?? ""} ${
    //   adressArray[0]?.VLCOMPLEMENTO ?? "-"
    // } | ${adressArray[1]?.DSCOMPLEMENTO ?? ""} ${
    //   adressArray[1]?.VLCOMPLEMENTO ?? "-"
    // } | ${adressArray[2]?.DSCOMPLEMENTO ?? ""} ${
    //   adressArray[2]?.VLCOMPLEMENTO ?? "-"
    // }`;
    // return string;
  };

  useEffect(() => {
    // setAddreesses(data);
    setLoading(true);
    if (!addresseeId) {
      (async () => {
        try {
          if (IDMCM) {
            const { data } = await addreessesService.getAll({ IDMCM });
            // parece que aqui pega o cliente
            const newData = formatDataToTable(data);
            const newArray = newData
              .map((item) => {
                return {
                  ...item,
                  ENDECOMPL: endComplement(
                    item.GRUPOUSUARIO[0].ENDERECO[0].ENDECOMPL
                  ),
                };
              })
              .sort((a, b) => (a.NMUSUARIO > b.NMUSUARIO ? 1 : -1));
            setAddreesses(newArray);
          }
        } catch (error: any) {
          verifyError(error?.response?.status);
          setAddreesses([]);
          setErrorMessage(error?.response?.data?.message);
        } finally {
          setLoading(false);
        }
      })();
    } else {
      (async () => {
        try {
          const { data } = await addreessesService.getOne(addresseeId);
          let addressee: any = data;
          addressee[0].TELEFONE = phoneWithMask(addressee[0].TELEFONE);
          setDataAddressee(addressee[0]);
          setLoading(false);
        } catch (error: any) {
          verifyError(error?.response?.status);
          setAddreesses([]);
          setErrorMessage(error?.response?.data?.message);
        } finally {
          setLoading(false);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [IDMCM]);

  const statusOptions = [
    {
      label: "ATIVO",
      value: "2",
    },
    {
      label: "PENDENTE INSTALAÇÃO",
      value: "1",
    },
    {
      label: "BLOQUEADO",
      value: "3",
    },
  ];

  const groupOptions = [
    {
      label: "ADMINISTRADOR",
      value: "1",
    },
    {
      label: "DESTINATÁRIO",
      value: "0",
    },
  ];

  function setDataAddressee(newData: IAddressee.Addressee) {
    data = newData;
  }

  function formatDataToTable(data: IAddressee.Addressee[]) {
    return data.map((addreesse) => {
      return {
        ...addreesse,
        TELEFONE: formatPhone(addreesse.TELEFONE),
        CPF: addreesse.CPF === "null" ? "-" : addreesse.CPF,
        DSMCM: concatArray(addreesse.GRUPOUSUARIO, "DSGRUPOUSUARIO"),
        ENDECOMPL: endComplement(
          addreesse.GRUPOUSUARIO[0].ENDERECO[0].ENDECOMPL
        ),
        DSGRUPOUSUARIO: concatArrayAndFormatData(
          addreesse.GRUPOUSUARIO,
          "FLUSERADM",
          getLevelUser
        ),
      };
    });
  }

  async function getAllAddreesses(params?: IAddressee.Params) {
    setLoading(true);
    try {
      const { data, status } = await addreessesService.getAll({
        ...params,
        IDMCM,
      });
      if (status === 204) return setAddreesses([] as IAddressee.Addressee[]);

      const newData = formatDataToTable(data);
      setAddreesses(newData);
    } catch (error: any) {
      setAddreesses([]);
      verifyError(error.response.status);
      setErrorMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  async function updateAddressee(values: IAddressee.Addressee) {
    setLoading(true);
    try {
      // toast.success('Usuário atualizado.');
      const res = await addreessesService.updateAddressee(values);
      setErrorMessage("");
      setDataAddressee(res.data);
      toast.success("Usuário atualizado.");
      router.back();
    } catch (error: any) {
      verifyError(error.response.status);
      setErrorMessage(error.response?.data?.message);
      setError(true);
      setSuccess(false);
      toast.error("Erro ao atualizar o usuário.");
    } finally {
      setLoading(false);
    }
  }

  async function updateStatusAddressees(
    addressees: IAddressee.Addressee[],
    STUSUARIO: number
  ) {
    const ids = addressees.map((addressee) => addressee.IDUSUARIO);
    const values = ids.map((id) => {
      return {
        IDUSUARIO: Number(id),
        STUSUARIO,
      };
    });

    try {
      await addreessesService.updateStatus(values);
      if (STUSUARIO === 0) toast.success("Usuário ativado.");
      if (STUSUARIO === 1) toast.success("Usuário desativado.");
      if (STUSUARIO === 2) toast.success("Usuário excluído.");
      setErrorMessage("");
      setSuccess(true);

      try {
        const { data, status } = await addreessesService.getAll({ IDMCM });
        if (status === 204) return setAddreesses([] as IAddressee.Addressee[]);

        const newData = formatDataToTable(data);
        setAddreesses(newData);
        setSelectedRows([] as Array<IAddressee.Addressee>);
      } catch (error: any) {
        verifyError(error.response.status);
        setErrorMessage(error?.response?.data?.message);
      }
    } catch (err: any) {
      verifyError(err.response.status);
      if (STUSUARIO === 0) toast.error("Erro ao ativar o usuário.");
      if (STUSUARIO === 1) toast.error("Erro ao desativar o usuário.");
      if (STUSUARIO === 2) toast.error("Erro ao excluir o usuário.");
      setErrorMessage(err.response?.data?.message);
      setError(true);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  }

  async function setPagination(OFFSET: number, LIMIT: number) {
    // try {
    //   setLoading(true);
    //   const { data } = await orderService.getAll({ OFFSET: OFFSET > 0 ? OFFSET : 0, LIMIT: 1000 });
    //   setAddreesses(data);
    // } catch (error) {
    //   } finally {
    //     setLoading(false);
    //   }
  }

  async function getAddreessesByFilters(params: IAddressee.Params) {
    setLoading(true);

    // if (Number(params.FLUSERADM) > -1) {

    //   const { data } = await addreessesService.getAll({ IDMCM });
    //   const filteredAddressees = data.filter(addresse => {
    //     return addresse.GRUPOUSUARIO.some(group => group.FLUSERADM === params.FLUSERADM);
    //   });
    //   setAddreesses(filteredAddressees);
    //   return setLoading(false);
    // }
    let data;

    try {
      if (Number(params.FLUSERADM) > -1) {
        const response = await addreessesService.getAll({ IDMCM });
        if (response?.status === 204)
          return setAddreesses([] as IAddressee.Addressee[]);
        data = response?.data;

        const filteredAddressees = data.filter((addresse) => {
          return addresse.GRUPOUSUARIO.some(
            (group) => group.FLUSERADM === Number(params.FLUSERADM)
          );
        });
        const newData = formatDataToTable(filteredAddressees);

        setAddreesses(newData);
      } else {
        const response = await addreessesService.getAll({ ...params, IDMCM });
        if (response?.status === 204)
          return setAddreesses([] as IAddressee.Addressee[]);
        data = response?.data;
        const newData = formatDataToTable(data);
        setAddreesses(newData);
      }
    } catch (error: any) {
      verifyError(error.response.status);
      setErrorMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  async function updateUserGroup(data: IAddressee.UpdateUserGroup) {
    try {
      await addreessesService.updateUserGroup(data);
      toast.success("Complemento atualizado.");
      return true;
    } catch (error: any) {
      verifyError(error.response.status);
      setErrorMessage(error.response?.data?.message);
      setError(true);
      return false;
    }
  }

  async function deleteUserGroup(data: IAddressee.DeleteUserGroup) {
    try {
      await addreessesService.deleteUserGroup(data);
      toast.success("Grupo de usuário e complemento excluído.");
    } catch (error: any) {
      verifyError(error.response.status);
      setErrorMessage(error.response?.data?.message);
      setError(true);
    }
  }

  async function addUserGroupd(data: IAddressee.AddUserGroup) {
    try {
      await addreessesService.addUserGroup(data);
      toast.success("Grupo de usuário e complemento adicionado.");
      return true;
    } catch (error: any) {
      verifyError(error.response.status);
      toast.error("Erro ao adicionar grupo de usuário e complemento.");
      setErrorMessage(error.response?.data?.message);
      setError(true);
      return false;
    }
  }

  return {
    loading,
    data,
    addreesses,
    setAddreesses,
    errorMessage,
    setPagination,
    setDataAddressee,
    getAllAddreesses,
    statusOptions,
    groupOptions,
    getAddreessesByFilters,
    success,
    setSuccess,
    error,
    setError,
    updateAddressee,
    updateStatusAddressees,
    successActivate,
    successInactivate,
    successDelete,
    setSuccessActivate,
    setSuccessInactivate,
    setSuccessDelete,
    selectedRows,
    setSelectedRows,
    updateUserGroup,
    deleteUserGroup,
    addUserGroupd,
    IDMCM,
  };
}
